import { render, staticRenderFns } from "./BaseHeaderBox.vue?vue&type=template&id=339aef91&scoped=true"
import script from "./BaseHeaderBox.vue?vue&type=script&lang=js"
export * from "./BaseHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./BaseHeaderBox.vue?vue&type=style&index=0&id=339aef91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339aef91",
  null
  
)

export default component.exports